
$(document).ready(function(){
	/* resizeEvent */
	var resizeTimer = null;
	var resizeWin = window.innerWidth;
	function resizeSet(){
		parallaxSet($(window).scrollTop());
	}
	function resizeEv(){
		if (resizeTimer || resizeWin == window.innerWidth) return;
		resizeTimer = setTimeout(function(){
			resizeSet();
			resizeTimer = null;
			resizeWin = window.innerWidth;
		},0);
	};
	$(window).on('orientationchange resize',resizeEv);
	resizeSet();

	/* scrollEvent */
	var scrollTimer = null;
	function scrollEv(){
		if (scrollTimer) return;
		scrollTimer = setTimeout(function(){
			parallaxSet($(window).scrollTop());
			scrollTimer = null;
		},0);
	};
	if ('ontouchstart' in window) {
		$(window).on('touchmove',scrollEv);
	} else {
		$(window).on('scroll',scrollEv);
	}
	scrollEv();
});
$(window).on('load', function(){
	$('body').addClass('load');
});



/**********************************************************
* parallaxSet */
function parallaxSet(pos){
	var win = Math.floor(window.innerHeight);
	var parallaxObj = [];
	$('.parallax').each(function(){
		parallaxObj.push([$(this),Math.floor($(this).offset().top+(win/4)),Math.floor($(this).offset().top+$(this).height()+window.innerHeight)]);
	});
	var cnt = parallaxObj.length;
	function check(){
		for (var i = 0; i < cnt; i++) {
			if (parallaxObj[i][1] < pos+win && parallaxObj[i][2] > pos && pos > 0) {
				parallaxObj[i][0].addClass('on');
			} else {
				parallaxObj[i][0].removeClass('on');
			}
		}
	}
	if (pos || pos == 0) check();
}